import { APIProvider } from "@vis.gl/react-google-maps";

// Chiave Google Maps condivisa da tutto il builder (mappa, Places, Directions).
export const GMAPS_KEY = (process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "").trim();

// Avvolge le pagine del builder: senza chiave i figli restano invariati (fallback elegante).
export const GmapsProvider = ({ children }) => {
    if (!GMAPS_KEY) return children;
    return <APIProvider apiKey={GMAPS_KEY}>{children}</APIProvider>;
};
